import React, { useState, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import { StaticImage } from 'gatsby-plugin-image'
import { Wrapper, Overlay, Children } from './style.css'

const HeroCategorias = ({
  title,
  selected,
  correctAnswer,
  onSelect,
  bgcolor,
  children,
  isCorrect,
}) => {
  const [isSelected, setSelected] = useState(false)

  const handleSelect = () => {
    onSelect(selected)
  }

  useEffect(() => {
    setSelected(selected ? true : false)
  }, [selected])

  const duration = 1000

  return (
    <Wrapper>
      <CSSTransition in={isSelected} timeout={duration} classNames="wrap">
        <div className="slide-wrap">
          <Overlay bgcolor={bgcolor}>
            <CSSTransition
              in={isSelected}
              timeout={duration}
              classNames="selectedwrap">
              <div className="selected bg-bermellon">
                <h3 className="pt-16 text-xl font-bold leading-none text-left md:text-4xl landscape:text-xl landscape:pt-10 ">
                  <small className="block mb-0 text-xl sm:mb-4 landscape:mb-0">
                    Tu respuesta:
                  </small>{' '}
                  {selected}
                  <small className="block mb-4 sm:mt-2 landscape:mb-0 landscape:mt-0 ">
                    es...
                  </small>
                </h3>
                <h2 className="text-5xl font-bold leading-none text-left text-verde delayed delayed1 md:text-7xl landscape:text-4xl ">
                  {isCorrect ? '¡Correcta!' : 'Incorrecta.'}
                </h2>
                <h3 className="block my-2 text-base leading-tight sm:my-8 sm:text-3xl landscape:text-base landscape:my-2 delayed delayed2">
                  {correctAnswer}
                </h3>
                <button
                  className="text-3xl font-bold underline sm:text-6xl landscape:text-3xl focus:outline-none"
                  onClick={() => handleSelect()}>
                  {' '}
                  Continuar
                </button>
              </div>
            </CSSTransition>
          </Overlay>
        </div>
      </CSSTransition>
    </Wrapper>
  )
}

export default HeroCategorias
